import { render, staticRenderFns } from "./ManageDebtorsToCheck.vue?vue&type=template&id=58827d3f&scoped=true"
import script from "./ManageDebtorsToCheck.vue?vue&type=script&lang=js"
export * from "./ManageDebtorsToCheck.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "58827d3f",
  null
  
)

export default component.exports